import React, {useState} from "react";
export default function DropDown(props) {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(props.detected);
    const select = (select,uri) => {
        setSelected(select)
       if(props.setSelect)
         props.setSelect(select)
        setOpen(false)
    }
    const openDropDown = () => {
        if(!props.disabled) setOpen(!open)
    }
    return(
        // onBlur={() => setOpen(false)}
           <div>
           <p className="f14 fw500 dark-gary-2 mb-2">{props.items[0]}</p>
           <div style={{width:296}} onClick={openDropDown} onBlur={() => setOpen(false)}  className={`mini-drop-down d-flex justify-content-between align-items-center  ${open && 'mini-drop-down-active'} ${props.className}`} tabIndex={-1}>
               <p>{selected}</p>
               {
                   !props.disabled &&

                       <svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="7.426" viewBox="0 0 12.732 7.426">
                           <g id="ArrowDown" transform="translate(-407.939 -377.939)">
                               <path id="Line_19" d="M0 5.305L5.305 0" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 396.653 -12.348)"/>
                               <path id="Line_20" d="M0 0L5.305 5.305" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 399.305 -15)"/>
                           </g>
                       </svg>
               }
               {open &&
               <div className="sub-select">
                   {props.items.map((value,key)=>(
                       <p key={key} onClick={() => select(value)}>{value}</p>
                   ))}
               </div>}
           </div>
           </div>
    )
}
